<template>
	<div>
		<div class="title">
			<div id="notice">
				<h5>公司汽车资料菜单使用说明:<br>
					<span>1、汽车编号构成规则:车辆类型+归属类型+4位顺序号。</span><br>
					<span>2、汽车配置自定义设置</span><br>
					<!-- <span>3、汽车配置使用不能直接删除,但是可以先注销不使用。</span><br> -->
					<span class="red">3、默认:车头=1,车挂=2,内部用车=3。归属类型:自有=1，挂靠=2，提户=3。可按需编辑分类</span><br>
					<span>4、查询关键字:汽车编号、车牌。</span><br>
					<span class="red">注:忽略后，如果需要继续跟踪，只需要在对应车牌的基础资料里修改状态即可!</span><br>
					<span class="red">注:车辆作废后,不提醒任何保险,也不会删除数据!</span><br>
				</h5>
			</div>
		</div>

		<pre-base ref="mybase" @base2-event="refresh_father" :pre_data="init_data">
			<template slot="pre_base_button">
				&nbsp;
				<button class="pre_btn_ok" @click="fun_detail">添加配置</button>
				<button class="pre_btn_ok" @click="fun_two">配置维护</button>
				<button class="pre_btn_ok" @click="fun_class">类别维护</button>
				<button class="pre_btn_ok" @click="fun_my">归属维护</button>
				<button class="pre_btn_ok" @click="fun_cargua">车挂分类</button>
				<button class="pre_btn_ok" @click="fun_show_lose">当前忽略信息</button>
				<button class="pre_btn_ok" @click="fun_show_carexpname">车挂别名</button>
			</template>

		</pre-base>

		<!-- 组件引入 -->

		<pre-tanone ref="carclass" @tan-event="refresh_data" />
		<pre-tanone ref="caruser" @tan-event="refresh_data" />
		<pre-tanone ref="carexp" @tan-event="refresh_data" />

		<pre-tanone ref="cardetail" @tan-event="refresh_data" />
		<pre-tanone ref="caritem" @tan-event="refresh_data" />


		<!-- 弹出待办业务单号 start -->
		<div class="tan_lose" id="pre_detail_data" v-show="show_lose">
			<span class="tan_lose_close">
				<img src="../../assets/image/shan1.png" @click="closeshow" />
			</span>
			<div class="content_edit ">
				<h3 class="red">忽略信息</h3>
			</div>
			<div class="content_edit ">
				<div class="pre_tab ">

					<table class="tab-hulue">

						<tr class="tab-header">
							<th>序号</th>
							<th class="short0 left">车牌</th>
							<th class="short0 left">名称</th>
							<th class="short0">日期</th>
							<th class="short0">类型</th>
						</tr>
						<tbody class="tab-body">
							<tr v-for="(item, index) in list_lose" :key="index">
								<td>{{ item.row_num }}</td>
								<td class="short0 left">{{item.car_no}}</td>
								<td class="short0">{{ item.lose_name }}</td>
								<td class="short0">{{ item.lose_date }}</td>
								<td class="short0">{{ item.lose_flag }}</td>
							</tr>
						</tbody>

					</table>

				</div>
			</div>
		</div>
		<!-- 弹出待办业务单号 end -->

		<!-- 点赞上传设置 -->
		<carbase-bieming ref="carbieming"></carbase-bieming>
	</div>
</template>

<script>
	import api from '@/utils/type.js';
	import {
		Method_EasySelect,
		Sel_page_and_length
	} from '@/utils/loadhttpdata.js';
	export default {
		components: {
			"pre-base": () => import("./car_base2_tab.vue"),
			"pre-tanone": () => import("../per_old/pre_tan_one.vue"),
			"pre-tandetail": () => import("../per_old/pre_base_tan_detail.vue"),
			'carbase-bieming': () => import("../base_tan/tan_carbase_bieming.vue")
		},
		data() {
			return {
				element_loading: false,
				init_data: '',
				row_id: '',

				t_data: [],
				// 组件
				show_tan: '0',
				show_item: '',
				show_one: '0',
				one_item: '',
				show_two: '0',
				two_item: '',


				list_lose: [],
				lose_name: '',
				show_lose: false
			};
		},
		mounted: function() {
			var that = this;
			this.$nextTick(function() {
				that.fun_init();
			});
		},
		methods: {
			fun_init() {
				this.init_data = '';
				this.init_data = JSON.stringify({
					"title": "汽车基础资料",
					"control": "car_base",
					"isTwo": "1",
					"isTwoDetail": "1",
					"action_flag": "",
					"isFileMain": "1",
					"sel_action": 'exp_car_carbase',
					"upd_action": 'exp50_carbase',
					"detail_part": "1",
					"d_sel_action": '',
					"d_upd_action": '',
					"file_action": 'filemore',
					"p1": 'car',
					"p2": 'info',
					"p3": 'base',
					"parm_sel": [{
							"name": "车架号",
							"val": "",
							"key": "c_frame",
							"type": "text",
							"class": "long2",
							"sel": "1"
						},
						{
							"name": "车牌号码",
							"val": "",
							"key": "c_no",
							"type": "text",
							"class": "long1",
							"weight": "1",
							"sel": "2"
						},

						{
							"name": "汽车分类",
							"val": "",
							"key": "c_class",
							"type": "select",
							"class": "long1",
							"weight": "1",
							"sel_action": "_base_carclass",
							"sel_name": "",
							"sel": "3"
						},
						{
							"name": "汽车归属",
							"val": "",
							"key": "c_flag",
							"type": "select",
							"class": "long1",
							"sel_action": "_base_caruser",
							"sel_name": "",
							"sel": "4"
						},
						{
							"name": "车型",
							"val": "",
							"key": "c_name",
							"type": "text",
							"class": "long1",
							"sel": "5"
						},
						{
							"name": "所属人/公司",
							"val": "",
							"key": "c_user",
							"type": "text",
							"class": "long1",
							"sel": "6"
						},
						{
							"name": "车挂别名",
							"val": "",
							"key": "car_gua_bm",
							"type": "text",
							"class": "long1",
							"sel": "7"
						}


					],
					"parm": [{
							"name": "汽车编号",
							"val": "",
							"key": "sheet_no",
							"type": "text",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "1",
							"x": "1"

						},
						{
							"name": "车牌号码",
							"val": "",
							"key": "c_no",
							"type": "text",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						},
						{
							"name": "车架号",
							"val": "",
							"key": "c_frame",
							"type": "text",
							"class": "long2",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						},
						{
							"name": "汽车分类",
							"val": "",
							"key": "c_class",
							"type": "select",
							"class": "long1",
							"sel_action": "_base_carclass",
							"sel_name": "",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "2"
						},
						{
							"name": "汽车归属",
							"val": "",
							"key": "c_flag",
							"type": "select",
							"class": "long1",
							"sel_action": "_base_caruser",
							"sel_name": "",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "2"
						},
						{
							"name": "车挂分类",
							"val": "",
							"key": "c_exp_flag",
							"type": "select",
							"class": "long1",
							"sel_action": "_base_carflag",
							"sel_name": "",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "2"
						},
						{
							"name": "车型",
							"val": "",
							"key": "c_name",
							"type": "text",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "3"
						},
						{
							"name": "所属人/公司",
							"val": "",
							"key": "c_user",
							"type": "text",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "3"
						},
						{
							"name": "购买日期",
							"val": "",
							"key": "buy_date",
							"type": "date",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "3"
						},
						{
							"name": "购买价格",
							"val": "",
							"key": "buy_price",
							"type": "number",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "3"
						},
						{
							"name": "里程",
							"val": "",
							"key": "c_distance",
							"type": "number",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "3"
						},
						{
							"name": "核定载重",
							"val": "",
							"key": "c_weight",
							"type": "number",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "4"
						},
						{
							"name": "油耗载重",
							"val": "",
							"key": "c_w_oil",
							"type": "number",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "4"
						},
						{
							"name": "油耗空车",
							"val": "",
							"key": "c_w_empty",
							"type": "number",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "4"
						},

						{
							"name": "月折旧",
							"val": "",
							"key": "month_lost",
							"type": "number",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "4"
						},
						{
							"name": "发动机号",
							"val": "",
							"key": "engine",
							"type": "text",
							"class": "long2",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "4"
						},
						{
							"name": "行驶证编号",
							"val": "",
							"key": "reg_no",
							"type": "text",
							"class": "long1_3",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "5"
						},
						{
							"name": "行驶证机构",
							"val": "",
							"key": "reg_name",
							"type": "text",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "5"
						},
						{
							"name": "行驶证注册",
							"val": "",
							"key": "reg_sdate",
							"type": "date",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "5"
						},
						{
							"name": "行驶证截至",
							"val": "",
							"key": "reg_edate",
							"type": "date",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "5"
						},
						{
							"name": "报废日期",
							"val": "",
							"key": "c_lose",
							"type": "date",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "5"
						},
						{
							"name": "营运证编号",
							"val": "",
							"key": "oper_no",
							"type": "text",
							"class": "long1_3",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "6"
						},
						{
							"name": "营运证机构",
							"val": "",
							"key": "oper_name",
							"type": "text",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "6"
						},
						{
							"name": "营运证注册",
							"val": "",
							"key": "oper_sdate",
							"type": "date",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "6"
						},
						{
							"name": "营运证截至",
							"val": "",
							"key": "oper_edate",
							"type": "date",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "6"
						},
						{
							"name": "审车期限",
							"val": "",
							"key": "check_date",
							"type": "date",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "7"
						},
						{
							"name": "商业险",
							"val": "",
							"key": "insurance_date",
							"type": "date",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "7"
						},
						{
							"name": "商业险提醒",
							"val": "",
							"key": "syx_flag",
							"type": "select",
							"class": "long1",
							"sel_action": "",
							"list": [{
								"id": "1",
								"val": "是"
							}, {
								"id": "2",
								"val": "否"
							}],
							"sel_name": "",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "7"
						},
						{
							"name": "交强险",
							"val": "",
							"key": "insurance2_date",
							"type": "date",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "8"
						},
						{
							"name": "交强险提醒",
							"val": "",
							"key": "jqx_flag",
							"type": "select",
							"class": "long1",
							"sel_action": "",
							"list": [{
								"id": "1",
								"val": "是"
							}, {
								"id": "2",
								"val": "否"
							}],
							"sel_name": "",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "8"
						},
						{
							"name": "备注",
							"val": "",
							"key": "note",
							"type": "text",
							"class": "long2",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "8"
						},
					],
					"parm_th": [{
							"name": "序号"
						},
						{
							"name": "汽车编号"
						},
						{
							"name": "车牌号码"
						},
						{
							"name": "车架号"
						},
						{
							"name": "汽车分类"
						},
						{
							"name": "汽车归属"
						},
						{
							"name": "车挂分类"
						},
						{
							"name": "别名"
						},
						{
							"name": "车型"
						},
						{
							"name": "所属人/公司"
						},
						{
							"name": "有无附件"
						},
						{
							"name": "购买日期"
						},
						{
							"name": "购买价格"
						},

						{
							"name": "核定载重"
						},
						{
							"name": "百公里油耗(载重)"
						},
						{
							"name": "百公里油耗(空车)"
						},

						{
							"name": "月折旧"
						},
						{
							"name": "里程"
						},
						{
							"name": "发动机号"
						},

						{
							"name": "行驶证编号"
						},
						{
							"name": "行驶证发证机构"
						},
						{
							"name": "行驶证注册日期"
						},
						{
							"name": "行驶证截至日期"
						},
						{
							"name": "强制报废日期"
						},
						{
							"name": "营运证编号"
						},
						{
							"name": "营运证发证机构"
						},
						{
							"name": "营运证注册日期"
						},
						{
							"name": "营运证截至日期"
						},
						{
							"name": "备注"
						},
						{
							"name": "审车有效期"
						},
						{
							"name": "商业险"
						},
						{
							"name": "商业险提醒"
						},
						{
							"name": "交强险"
						},
						{
							"name": "交强险提醒"
						},
						{
							"name": "配置明细"
						},
						{
							"name": "状态"
						},
						{
							"name": "修改人"
						},
						{
							"name": "存储地址"
						},
						{
							"name": "访问地址"
						},
						{
							"name": "修改时间"
						}
					],
					"d_parm": [{
							"name": "配置信息",
							"d_sel_action": "exp_car_cardetail",
							"d_name": [{
									"name": "序号"
								}, 
								{
									"name": "配置名称"
								},
								{
									"name": "说明"
								},
								{
									"name": "修改人"
								},
								{
									"name": "路径1"
								},
								{
									"name": "路径2"
								}, 
								{
									"name": "更新日期"
								}
							]
						},
						{
							"name": "保险登记",
							"d_sel_action": "exp_car_carInsur",
							"d_name": [{
									"name": "序号"
								},
								{
									"name": "单号"
								},
								{
									"name": "车牌号码"
								},
								// {
								//   "name": "保险名称"
								// }, {
								//   "name": "保险项目"
								// }, {
								//   "name": "保险期限"
								// },
								{
									"name": "总费用"
								},
								{
									"name": "备注",
									"class": "long2"
								},
								{
									"name": "附件"
								},
								{
									"name": "经办人"
								},
								{
									"name": "明细",
									"class": "long2"
								},
								{
									"name": "状态",
									"class": "short0"
								},
								{
									"name": "修改人",
									"class": "short0"
								},
								{
									"name": "路径1"
								},
								{
									"name": "路径2"
								},
								{
									"name": "修改时间",
									"class": "long2"
								}
							]
						},
						{
							"name": "保养登记",
							"d_sel_action": "data_exp_car_carMaint",
							"d_name": [{
									"name": "序号"
								}, {
									"name": "单号"
								}, {
									"name": "车牌号码"
								},
								{
									"name": "挂车别名"
								},
								// {
								//   "name": "保养项目"
								// },
								{
									"name": "总费用"
								},
								{
									"name": "保养日期"
								},
								{
									"name": "保养时里程"
								},
								{
									"name": "备注"
								},
								{
									"name": "附件"
								},
								{
									"name": "经办人"
								},
								{
									"name": "明细"
								},
								{
									"name": "状态"
								},
								{
									"name": "修改人"
								},
								{
									"name": "路径1"
								},
								{
									"name": "路径2"
								},
								{
									"name": "修改日期"
								}
							]
						},
						{
							"name": "审车登记",
							"d_sel_action": "exp_car_carCheck",
							"d_name": [{
									"name": "序号"
								}, {
									"name": "单号"
								},
								{
									"name": "车牌号码"
								},
								{
									"name": "车挂别名"
								},
								{
									"name": "总费用"
								},
								{
									"name": "备注",
									"class": "long2"
								},
								{
									"name": "附件"
								},
								{
									"name": "明细",
									"class": "long2"
								},
								{
									"name": "经办人",
									"class": "short0"
								},
								{
									"name": "状态",
									"class": "short0"
								},
								{
									"name": "修改人",
									"class": "short0"
								},
								{
									"name": "路径1"
								},
								{
									"name": "路径2"
								},
								{
									"name": "修改时间",
									"class": "long2"
								}
							]
						},
						{
							"name": "维修登记",
							"d_sel_action": "data_exp_car_carRepair",
							"d_name": [{
									"name": "序号"
								}, {
									"name": "单号"
								},
								{
									"name": "关联业务"
								},
								{
									"name": "车牌号码"
								},
								{
									"name": "挂车别名"
								},
								{
									"name": "维修厂"
								},
								{
									"name": "维修日期"
								},
								{
									"name": "总费用"
								},
								{
									"name": "维修说明"
								},
								{
									"name": "备注"
								},
								{
									"name": "附件"
								},
								{
									"name": "经办人"
								},
								{
									"name": "明细"
								},
								{
									"name": "状态"
								},
								{
									"name": "修改人"
								},
								{
									"name": "附件1"
								},
								{
									"name": "附件2"
								},
								{
									"name": "修改时间"
								}
							]
						},
						{
							"name": "违章登记",
							"d_sel_action": "data_exp_car_carViolover",
							"d_name": [{
									"name": "序号"
								},
								{
									"name": "单号"
								},
								{
									"name": "关联业务"
								},
								{
									"name": "状态"
								},
								{
									"name": "是否消除"
								},
								{
									"name": "车牌号码"
								},
								{
									"name": "别名"
								},
								{
									"name": "汽车归类"
								},
								{
									"name": "罚单编号"
								},
								{
									"name": "登记凭证"
								},
								{
									"name": "罚单日期"
								},
								{
									"name": "总金额"
								},
								{
									"name": "违章司机"
								},
								{
									"name": "违章跟车员"
								},
								{
									"name": "货物名称"
								},
								{
									"name": "违章地址"
								},
								{
									"name": "违章详情"
								},
								{
									"name": "附件"
								},
								{
									"name": "扣分"
								},
								{
									"name": "罚款金额"
								},
								{
									"name": "消分费用"
								},
								{
									"name": "滞纳金"
								},
								{
									"name": "司机承担费用"
								},

								{
									"name": "备注"
								},
								{
									"name": "违章备注"
								},
								{
									"name": "经办人"
								},
								{
									"name": "修改人"
								},
								{
									"name": "地址1"
								},
								{
									"name": "地址2"
								},
								{
									"name": "修改时间"
								}
							]
						},
						{
							"name": "事故登记",
							"d_sel_action": "exp_car_carAcci",
							"d_name": [{
									"name": "序号"
								}, {
									"name": "单号"
								},
								{
									"name": "车牌号码"
								},
								{
									"name": "挂车别名"
								},
								{
									"name": "事故地点",
									"class": "long2"
								},
								{
									"name": "事故日期"
								},
								{
									"name": "总金额"
								},
								{
									"name": "肇事司机"
								},
								{
									"name": "备注",
									"class": "long2"
								},
								{
									"name": "附件"
								},
								{
									"name": "经办人"
								},
								{
									"name": "状态"
								},
								{
									"name": "修改人"
								},
								{
									"name": "路径1"
								},
								{
									"name": "路径2"
								},
								{
									"name": "修改时间"
								}
							]
						},

					]
				});

			},
			refresh_data: function() {
				var that = this;
				this.$nextTick(function() {
					that.$refs['mybase'].refresh_data();
				});
			},
			refresh_children: function(type, id, val) {
				var that = this;
				this.$nextTick(function() {
					that.$refs['mybase'].refesh_parm(type, id, val);
				});
			},
			refresh_father: function(type, val, item) {
				// console.log('type=' + type + ' val=' + val);
				switch (type) {

					default:
						// console.log('子组件刷新父组件传值=' + val);
						// console.log(item);
						this.row_id = val;
						this.t_data = item;

						break;
				}
			},
			/*****************************************************/
			fun_class: function() {
				let parm = '';
				parm = JSON.stringify({
					"action": 'car_carclass',
					"title": '汽车类别维护',
					"parm": [{
							"name": "名称",
							"val": "",
							"key": "val"
						},
						{
							"name": "标识",
							"val": "",
							"key": "note"
						}
					],
					"parm_th": [{
							"name": "序号"
						}, {
							"name": "名称"
						}, {
							"name": "状态"
						},
						{
							"name": "标识"
						},
						{
							"name": "修改人"
						},
						{
							"name": "更新时间"
						}
					]
				});
				// this.show_one = (Math.random() + '').substring(0, 8);
				var that = this;
				this.$nextTick(function() {
					that.$refs['carclass'].load_data(parm);
				});
			},
			fun_my: function() {
				let parm = '';
				parm = JSON.stringify({
					"action": 'car_caruser',
					"title": '汽车归属维护',
					"parm": [{
							"name": "名称",
							"val": "",
							"key": "val"
						},
						{
							"name": "标识",
							"val": "",
							"key": "note"
						}
					],
					"parm_th": [{
							"name": "序号"
						}, {
							"name": "名称"
						}, {
							"name": "状态"
						},
						{
							"name": "标识"
						},
						{
							"name": "修改人"
						},
						{
							"name": "更新时间"
						}
					]
				});
				// this.show_one = (Math.random() + '').substring(0, 8);
				var that = this;
				this.$nextTick(function() {
					that.$refs['caruser'].load_data(parm);
				});
			},
			fun_cargua: function() {
				let parm = '';
				parm = JSON.stringify({
					"action": 'car_carexp',
					"title": '车挂分类维护',
					"parm": [{
							"name": "名称",
							"val": "",
							"key": "val"
						},
						{
							"name": "标识",
							"val": "",
							"key": "note"
						}
					],
					"parm_th": [{
							"name": "序号"
						}, {
							"name": "名称"
						}, {
							"name": "状态"
						},
						{
							"name": "标识"
						},
						{
							"name": "修改人"
						},
						{
							"name": "更新时间"
						}
					]
				});
				// this.show_one = (Math.random() + '').substring(0, 8);
				var that = this;
				this.$nextTick(function() {
					that.$refs['carexp'].load_data(parm);
				});
			},
			fun_show_lose: function() {
				this.element_loading = true;
				this.list_lose = [];

				let r = (Math.random() + '').substring(0, 8);

				this.$post(
					api.http_method, Sel_page_and_length('exp_warninglose', 1, 999)
				).then(res => {
					this.element_loading = false;
					res = JSON.parse(res);
					if (res.length > 0) {

						let t = res[0];
						for (let i = 0; i < t.length; i++) {
							let o = {};

							o = t[i];
							o.row_num = i + 1;
							this.list_lose.push(o);
						}
					}

					console.log(this.list_lose);
					if (this.list_lose.length > 0) {
						this.show_lose = true;
					}

				});
			},
			fun_show_carexpname: function() {
				// console.log('弹窗-别名绑定。', this.t_data);

				if (this.row_id == 0) {
					this.$message({
						message: '请选择要修改的数据!',
						type: 'warning'
					});
					return;
				}

				let carclassname = '',
					carno = '';
				for (let i = 0; i < this.t_data.length; i++) {
					switch (this.t_data[i].key) {
						case 'c_class':
							carclassname = this.t_data[i].val;
							break;
						case 'c_no':
							carno = this.t_data[i].val;
							break;
						default:
							break;
					}
				}

				if (carclassname !== '车挂') {
					this.$message({
						message: '只有车挂才能设置别名哦!',
						type: 'warning'
					});
					return;
				}

				let car_no = carno;
				console.log('car_no=' + car_no);
				let transdata = '';
				transdata = JSON.stringify({
					"title": carno + " 别名设置",
					"sheet_no": carno,
					"sel_action": "exp_car_carbiemingset",
					"upd_action": "car_carbiemingset",
					"parm": [{
							"name": "别名",
							"val": "",
							"key": "bieming",
							"type": "text",
							"class": "long1",
							"val": "",
							"p": "1",
							"w": "1",
							"r": "0",
							"x": "1"
						},
						{
							"name": "备注",
							"val": "",
							"key": "note",
							"type": "text",
							"note": "",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "2"
						}
					]
				})
				this.$refs.carbieming.showpop(transdata);
			},
			closeshow: function() {
				this.show_lose = false;
			},
			/*****************************************************/
			fun_detail: function() {
				// console.log('row_id='+this.row_id);
				let carno = '';
				for (let i = 0; i < this.t_data.length; i++) {
					switch (this.t_data[i].key) {
						case 'c_no':
							carno = this.t_data[i].val;
							break;
						default:
							break;
					}
				}

				if (Number(this.row_id) == 0) {
					this.$message({
						message: '请选择要操作的汽车信息!',
						type: 'warning'
					});
					return;
				}




				let parm = '';
				parm = JSON.stringify({
					"sheet_no": carno,
					"sel_action": "exp_car_cardetail",
					"action": 'car_cardetail',
					"title": '汽车配置明细',
					"parm": [{
						"name": "配置名称",
						"val": "",
						"key": "item_name"
					}, {
						"name": "配置内容",
						"val": "",
						"key": "item_val"
					}],
					"parm_th": [{
						"name": "序号"
					}, {
						"name": "车牌号"
					}, {
						"name": "配置名称"
					}, {
						"name": "配置内容"
					}, {
						"name": "修改人"
					}, {
						"name": "修改时间"
					}],
					"keyword": carno
				});
				var that = this;
				this.$nextTick(function() {
					that.$refs['cardetail'].load_data(parm);
				});

			},
			fun_two: function() {

				let parm = '';
				parm = JSON.stringify({
					"sel_action": "exp_car_caritem",
					"action": 'car_caritem',
					"title": '汽车配置维护',
					"parm": [{
							"name": "名称",
							"val": "",
							"key": "val"
						},
						{
							"name": "顺序",
							"val": "",
							"key": "step"
						}
					],
					"parm_th": [{
						"name": "序号"
					}, {
						"name": "名称"
					}, {
						"name": "顺序"
					}, {
						"name": "状态"
					}]
				});
				// this.show_two = (Math.random() + '').substring(0, 8);

				var that = this;
				this.$nextTick(function() {
					that.$refs['caritem'].load_data(parm);
				});
			},



		}
	};
</script>
<style scoped>
	.tab-hulue {
		max-height: 50vh;
		display: inline-block;
	}

	.tab-header th {
		/* 纵向渐变 */
		/* Safari 5.1 - 6.0 */
		background: -webkit-linear-gradient(#3da5d9, #a2d2ff);
		/* Opera 11.1 - 12.0 */
		background: -o-linear-gradient(#3da5d9, #a2d2ff);
		/* Firefox 3.6 - 15 */
		background: -moz-linear-gradient(#3da5d9, #a2d2ff);
		/* 标准的语法（必须放在最后） */
		background: linear-gradient(#3da5d9, #a2d2ff);
		text-align: center;
		color: #000000;
		font-size: 14px;
		font-weight: 400;
	}

	.tan_lose {
		position: absolute;
		top: 16%;
		left: 20%;
		background-color: rgba(0, 0, 0, 0.5);
		/* opacity: 0.2; */
		/* border: 1px solid black; */
		/* padding-left: 20px; */
		/* padding-right: 20px; */
		border-radius: 5px;
		z-index: 3;
		width: 60%;
		text-align: center;
		padding: 20px;
		overflow-x: auto;
	}

	.tan_lose_close>img {
		width: 24px;
		height: auto;
		position: absolute;
		right: 24px;
		top: 24px;
		cursor: pointer;
	}

	.tab-body {
		min-height: 200px;
		max-height: 60vh;
	}
</style>